module.exports = __webpack_public_path__ + "static/media/blog5-image.def8baf7.jpg";